export default {
  /*
   * Precios de productos
   */
  productPrice(params) {
    return Vue.http.post('billing/search_product_price', params).then(
      response => response.data.data
    )
  },
  /*
   * Valida producto
   */
  productValidate(params) {
    return Vue.http.post('billing/recharge_product_request', params).then(
      response => response.data.data
    )
  },
  /*
   * create() crea una recarga de producto
   */
  create(params) {
    return Vue.http.post('billing/product_recharge', params).then(response => response.data.data)
  },
  /*
   * show() devuelve los datos de una recarga
   */
  show(id, params) {
    return Vue.http.get(`billing/product_recharge/${id}`, params).then(
      response => response.data.data
    )
  },
  /*
   * complete_product_recharge() complete recharge with zero amount
   */
  complete_product_recharge(params) {
    return Vue.http.post('billing/complete_product_recharge', params).then(response => response.data.data)
  },
}
